var map = {
	"./AAVE.svg": 505,
	"./ADA.svg": 506,
	"./ADX.svg": 507,
	"./ANY.png": 508,
	"./ATOM.png": 509,
	"./AVAX.png": 510,
	"./AXS.png": 511,
	"./BABYCAKE.svg": 512,
	"./BAKE.png": 513,
	"./BANANA.svg": 514,
	"./BCH.svg": 515,
	"./BDO.png": 516,
	"./BETH.png": 517,
	"./BHC.png": 518,
	"./BIFI.png": 519,
	"./BMON.svg": 520,
	"./BNB.png": 521,
	"./BONE.png": 522,
	"./BONEswap.png": 523,
	"./BOO.png": 524,
	"./BORING.png": 525,
	"./BSCPAD.png": 526,
	"./BTCB.svg": 527,
	"./BTD.png": 528,
	"./BTS.png": 529,
	"./BTT.png": 530,
	"./BUNNY.png": 531,
	"./BURGER.png": 532,
	"./BUSD.svg": 533,
	"./CAKE.svg": 534,
	"./CARROT.png": 535,
	"./CHESS.svg": 536,
	"./CRV.png": 537,
	"./CTK.png": 538,
	"./DAI.png": 539,
	"./DAI.svg": 540,
	"./DFYN.png": 541,
	"./DG.png": 542,
	"./DINO.png": 543,
	"./DOT.png": 544,
	"./DRUGS.png": 545,
	"./DVI.svg": 546,
	"./EPS.png": 547,
	"./ETH.svg": 548,
	"./EZ.png": 549,
	"./FANTOM.png": 550,
	"./FFF.png": 551,
	"./FIL.svg": 552,
	"./FISH.svg": 553,
	"./FORM.svg": 554,
	"./FRUIT.png": 555,
	"./FTM.png": 556,
	"./GUARD.svg": 557,
	"./HAI.png": 558,
	"./HARD.png": 559,
	"./HBTC.png": 560,
	"./HECO.png": 561,
	"./HERO.png": 562,
	"./HONEY.png": 563,
	"./HONOR.png": 564,
	"./HPS.png": 565,
	"./HT.png": 566,
	"./HTB.svg": 567,
	"./HUSD.png": 568,
	"./ICA.svg": 569,
	"./ICE.png": 570,
	"./IF.svg": 571,
	"./INCH.png": 572,
	"./INJ.png": 573,
	"./JETS.png": 574,
	"./JULD.png": 575,
	"./KEBAB.png": 576,
	"./KRW.png": 577,
	"./LINK.png": 578,
	"./LITHIUM.svg": 579,
	"./LTC.svg": 580,
	"./LUNA.png": 581,
	"./MAI.png": 582,
	"./MARSH.png": 583,
	"./MASK.svg": 584,
	"./MATIC.svg": 585,
	"./MCRN.svg": 586,
	"./MDX.png": 587,
	"./MERL.svg": 588,
	"./METAHERO.svg": 589,
	"./MIM.png": 590,
	"./MSC.png": 591,
	"./MSS.png": 592,
	"./MUST.png": 593,
	"./NEXO.png": 594,
	"./NUTS.png": 595,
	"./NYA.png": 596,
	"./NYAC.png": 597,
	"./NYAS.png": 598,
	"./O3.png": 599,
	"./ONE.svg": 600,
	"./ONT.png": 601,
	"./OOE.svg": 602,
	"./ORBS.svg": 603,
	"./PAUTO.png": 604,
	"./PBNB.png": 605,
	"./PERA.png": 606,
	"./PMP.svg": 607,
	"./PNG.svg": 608,
	"./POLYGON.png": 609,
	"./POTS.png": 610,
	"./PUP.png": 611,
	"./PolyDoge.png": 612,
	"./QI.png": 613,
	"./QUICK.png": 614,
	"./RABBIT.svg": 615,
	"./RAMP.png": 616,
	"./REVV.svg": 617,
	"./ROUTE.png": 618,
	"./SBDO.png": 619,
	"./SFP.png": 620,
	"./SISTA.svg": 621,
	"./SKILL.svg": 622,
	"./SMART.png": 623,
	"./SNX.png": 624,
	"./SOAK.png": 625,
	"./SPIRIT.png": 626,
	"./SPS.svg": 627,
	"./STARS.svg": 628,
	"./START.png": 629,
	"./STEEL.png": 630,
	"./SUSHI.png": 631,
	"./SWAMP.svg": 632,
	"./SX.png": 633,
	"./SXP.svg": 634,
	"./TAPE.svg": 635,
	"./TEL.png": 636,
	"./TENFI.png": 637,
	"./TITAN.svg": 638,
	"./TRX.png": 639,
	"./TYPH.png": 640,
	"./UFT.png": 641,
	"./UNI.png": 642,
	"./USDC.svg": 643,
	"./USDT.svg": 644,
	"./UST.png": 645,
	"./WATCH.png": 646,
	"./WAULTx.svg": 647,
	"./WBNB.svg": 648,
	"./WBTC.svg": 649,
	"./WEX.svg": 650,
	"./WIN.png": 651,
	"./WMATIC_DFYN.svg": 652,
	"./WOO.svg": 653,
	"./WOOFY.png": 654,
	"./WSG.svg": 655,
	"./XRP.svg": 656,
	"./XTZ.png": 657,
	"./XVS.png": 658,
	"./YAMP.svg": 659,
	"./YELD.png": 660,
	"./YFI.png": 661,
	"./ZBTC.svg": 662,
	"./ZETH.svg": 663,
	"./cakeHARD.png": 664,
	"./cakeROOBEE.png": 665,
	"./cakeSTAX.png": 666,
	"./cakeTWT.png": 667,
	"./cakebROOBEE.png": 668,
	"./fUSDT.png": 669,
	"./ibBTC.svg": 670,
	"./pWINGS.png": 671,
	"./polyBUNNY.png": 672,
	"./rUSD.svg": 673,
	"./renBTC.png": 674,
	"./renDGB.svg": 675,
	"./sALPACA.svg": 676,
	"./xMARK.png": 677,
	"./xYELD.svg": 678
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1288;